export default "__VITE_ASSET__98649025__"